import React from 'react';

const DropdownCard = ({
  data = [],
  setOpen,
}) => {
  return (
    <>
      <div className='dropdownCard' style={{
        position: 'absolute',
      }}>
        <ul className='dropdownCard-list'>
          {data.map((item, i) => (
            <li className='dropdownCard-list-item' key={i} onClick={() => setOpen(false)}>
              <a target={item.target} href={item.url}><strong>{item.text}</strong><span>{item.subtext}</span></a>
            </li>
          ))}
        </ul>
      </div>
      <style jsx global>
        {`
        .dropdownCard {
          position: absolute;
          background-color: white;
          list-style: none;
          width: 100%;
          border: 1px solid #d1d1d1;
          top: 43px;
          border-radius: 10px
        }

        .dropdownCard-list {
          list-style: none;
          padding: 0px;
        }

        .dropdownCard-list-item strong {
          margin-bottom: -5px;
          display: block;
        }

        .dropdownCard-list-item {
          padding: 10px;
        }

        .dropdownCard-list-item:hover {
          background-color: #d1d1d1;
        }

        .dropdownCard-list-item:not(:last-child) {
          border-bottom: 1px solid #d1d1d1;
        }

        .dropdownCard-list-item span {
          font-size: 0.9rem;
        }

        .dropdownCard-list-item a {
          color: #000000;
          text-decoration: none;
          font-size: 1rem;
        }
      `}
      </style>

    </>
  )
};

export default DropdownCard;
